import i18n from "@/plugins/i18n";

export const elasticacheSubscriptionPageTabs = [
  {
    label: i18n.global.t("aws.host"),
    slug: "Host",
    disbled: false,
  },
  {
    label: i18n.global.t("aws.redis"),
    slug: "Redis",
    disbled: false,
  },
  {
    label: i18n.global.t("aws.memcached"),
    slug: "Memcached",
    disbled: false,
  },
];

export const elasticacheTilesHeader = () => [
  {
    key: "service_eca_host_new_connections",
    tileName: i18n.global.t("aws.totalNewConnections"),
    name: i18n.global.t("aws.totalNewConnections"),
    tooltip: i18n.global.t("aws.totalNewConnectionsTooltip"),
  },
  {
    key: "service_eca_host_evictions",
    tileName: i18n.global.t("aws.totalEvictions"),
    name: i18n.global.t("aws.totalEvictions"),
    tooltip: i18n.global.t("aws.totalEvictionsTooltip"),
  },
  {
    key: "service_eca_host_memory_usage_by_cluster",
    tileName: i18n.global.t("aws.memoryUsageByCluster"),
    name: i18n.global.t("aws.memoryUsageByCluster"),
    tooltip: i18n.global.t("aws.memoryUsageByClusterTooltip"),
  },
];

export const elastiCacheTabMapper = {
  1: "host",
  2: "REDIS",
  3: "MEMC",
};

export const elastiCacheTabHeaderMapper = {
  1: "Host",
  2: "Redis",
  3: "Memcached",
};

export enum elastiCacheTabMapperEnum {
  host = "host",
  REDIS = "REDIS",
  MEMC = "MEMC",
}

export enum elastiCacheClusterType {
  parent = "parent",
  child = "child"
}